const headerDescriptions = {
  pt: 'Acompanhe os principais indicadores de desempenho da sua operação conversacional. Essa visão reúne dados do portal Blip, permitindo entender o volume de DEUs e de mensagens ativas.',
  en: 'Track your conversational operation\'s key performance indicators. This view gathers data from the Blip portal, helping you understand the volume of DEUs and Proactive messages.',
  es: 'Sigue los principales indicadores de rendimiento de tu operación conversacional. Esta vista reúne datos del portal Blip y te permite entender el volumen de DEUs y de Mensajes proactivos.',
};

const chartLabels = {
  pt: {
    labels: {
      counted: 'Mensagens Ativas',
      available: 'DEUs',
    },
    customLabels: {
      counted: 'DEUs consumidos',
      available: 'Mensagens Ativas',
    },
  },
  en: {
    labels: {
      counted: 'Proactive Messages',
      available: 'DEUs',
    },
    customLabels: {
      counted: 'DEUs consumidos',
      available: 'Proactive Messages',
    },
  },
  es: {
    labels: {
      counted: 'Mensajes proactivos',
      available: 'DEUs',
    },
    customLabels: {
      counted: 'DEUs',
      available: 'Mensajes proactivos',
    },
  },
};

export const localization = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Uso do Plano',
      description: headerDescriptions.pt,
      learnMore: 'Saiba mais sobre os termos',
      modalContent: {
        title: 'Detalhamento dos Termos',
        description: '<strong>DEU (Daily Engaged User)</strong>: Usuário Diário Engajado único por chatbot principal (router). Será considerado um DEU todo usuário distinto que interagir, dentro de um mesmo dia (das 00h00 às 23h59, horário de Brasília), com algum chatbot principal/router de qualquer forma, seja respondendo ou enviando uma mensagem, clicando, ou realizando qualquer outro tipo de interação. Isso inclui qualquer usuário distinto que tenha enviado pelo menos uma mensagem ao chatbot principal/router, independentemente do tipo de mensagem (texto, imagem, documento, vídeo, áudio, clique em carrossel, quick reply, emoji ou cliques), em qualquer canal (como Whatsapp, RCS, Blip Chat). Para exemplificar, caso a empresa se comunique com o mesmo usuário distinto em dois números diferentes de WhatsApp no mesmo dia, serão contabilizados dois DEUs.',
        alert: '<strong>Mensagens Ativas</strong>: quaisquer mensagens por disparo ativo enviadas pela empresa, independentemente do engajamento (interação ou resposta) do usuário final.',
        action: 'Entendido',
      },
      showMoreButton: 'Ver mais',
      tooltipText: 'DEU (Daily Engaged User): Usuário Diário Engajado',
    },
    leftChart: {
      title: 'Consumo atual',
      ...chartLabels.pt,
    },
    leftInfoPaper: {
      totalInfo: {
        description: 'Volume de DEUs do mês atual',
      },
      availableInfo: {
        description: 'Volume de Mensagens ativas do mês atual',
      },
      planInfo: {
        description: 'Semana do mês selecionado que teve maior número de Mensagens ativas',
        tooltip: 'Número de Conversas Únicas disponíveis por mês no plano contratado',
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Consumo semanal de DEUs e Mensagens ativas',
      ...chartLabels.pt,
      warningLabel: {
        bold: 'Importante: ',
        regular:
          'usuários que receberem uma notificação ativa, mesmo que não a respondam, serão contabilizados. Várias mensagens podem ser trocadas com um mesmo usuário ativo, entre o período mencionado, contabilizando uma única conversa.',
      },
    },
    rightInfoPaper: {
      weeklyAverage: {
        description: 'Média semanal de consumo de DEUs',
      },
      weeklyMsgAverage: {
        description: 'Média semanal de consumo de Mensagens ativas',
      },
      topWeekNumber: {
        label: '{0} semana',
        description: 'Semana do mês selecionado com que teve o maior consumo de DEUs',
      },
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Plan Usage',
      description: headerDescriptions.en,
      learnMore: 'Learn more about the terms',
      modalContent: {
        title: 'Detailed explanation of terms',
        description: '<strong>DEU (Daily Engaged User)</strong>: Unique daily engaged user per main chatbot (router). Any single user who interacts with a main chatbot/router in any way within the same day (from 00:00 to 23:59 Brasília time), whether by sending or receiving a message, clicking, or performing any other type of interaction, will be counted as a DEU. This includes any single user who has sent at least one message to the main chatbot/router, regardless of the message type (text, image, document, video, audio, carousel click, quick reply, emoji, or other clicks) and across any channel (such as WhatsApp, RCS, Blip Chat). For example, if the company communicates with the same distinct user on two different WhatsApp numbers on the same day, they will be counted as two DEUs.',
        alert: '<strong>Proactive Messages</strong>: Any messages sent by the company through active dispatch, regardless of the end user’s engagement (interaction or response).',
        action: 'Close',
      },
      showMoreButton: 'See more',
      tooltipText: 'DEU (Daily Engaged User)',
    },
    leftChart: {
      title: 'Current usage',
      ...chartLabels.en,
    },
    leftInfoPaper: {
      totalInfo: {
        description: 'DEUs volume in the current month',
      },
      availableInfo: {
        description: 'Proactive messages volume in the current month',
      },
      planInfo: {
        description: 'Week of the selected month with the highest number of Proactive messages',
        tooltip: 'Number of Single Conversations available per month on your plan',
      },
    },
    rightChart: {
      period: '{startDate} to {endDate}',
      title: 'Weekly usage of DEUs and Proactive messages',
      ...chartLabels.en,
      warningLabel: {
        bold: 'Attention: ',
        regular:
          'every user that receives a proactive notification will be counted, even if they do not reply. Within the given period, multiple messages can be exchanged with the same active user, which counts as a single conversation.',
      },
    },
    rightInfoPaper: {
      weeklyAverage: {
        description: 'Average weekly consumption of DEUs',
      },
      weeklyMsgAverage: {
        description: 'Weekly average usage of proactive messages',
      },
      topWeekNumber: {
        label: '{0} week',
        description: 'Selected week of the month with the highest consumption of DEUs',
      },
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Uso del Plan',
      description: headerDescriptions.es,
      learnMore: 'Obtén más información sobre estos términos',
      modalContent: {
        title: 'Explicación detallada de los términos',
        description: '<strong>DEU (Usuario Comprometido Diario)</strong>: Usuario comprometido único por chatbot principal (router). Se considerará como DEU a todo usuario distinto que interactúe, dentro de un mismo día (de 00:00 a 23:59, horario de Brasília), con algún chatbot de cualquier forma, ya sea respondiendo o enviando un mensaje, haciendo clic, o realizando cualquier otro tipo de interacción. Esto incluye a cualquier usuario distinto que haya enviado al menos un mensaje al chatbot principal/router, independientemente del tipo de mensaje (texto, imagen, documento, video, audio, clic en carrusel, respuesta rápida, emoji o clics), y en cualquier canal (como WhatsApp, RCS, Blip Chat). Por ejemplo, si la empresa se comunica con el mismo usuario distinto en dos números diferentes de WhatsApp en el mismo día, se contabilizarán dos DEUs.',
        alert: '<strong>Mensajes Proactivos</strong>: Cualquier mensaje enviado mediante disparo activo por la empresa, independientemente del nivel de participación (interacción o respuesta) del usuario final.',
        action: 'Cerrar',
      },
      showMoreButton: 'Ver más',
      tooltipText: 'DEU (Daily Engaged User): Usuario Comprometido Diario',
    },
    leftChart: {
      title: 'Consumo actual',
      ...chartLabels.es,
    },
    leftInfoPaper: {
      totalInfo: {
        description: 'Volumen de DEUs del mes actual',
      },
      availableInfo: {
        description: 'Volumen de Mensajes proactivos del mes actual',
      },
      planInfo: {
        description: 'Semana del mes seleccionado con el mayor número de Mensajes proactivos',
        tooltip: 'Numero de Conversaciones Únicas disponibles por mes en el plan contratado',
      },
    },
    rightChart: {
      period: '{startDate} al {endDate}',
      title: 'Uso semanal de DEUs y Mensajes proactivos',
      ...chartLabels.es,
      warningLabel: {
        bold: 'Importante: ',
        regular:
          'los usuarios que reciban una notificación proactiva, aunque no la contesten, serán contabilizados. Se pueden intercambiar varios mensajes con el mismo usuario activo, entre el periodo mencionado, contando como una única conversación.',
      },
    },
    rightInfoPaper: {
      weeklyAverage: {
        description: 'Consumo promedio semanal de DEUs',
      },
      weeklyMsgAverage: {
        description: 'Promedio semanal de consumo de mensajes proactivos',
      },
      topWeekNumber: {
        label: '{0} semana',
        description: 'Semana seleccionada del mes con mayor consumo de DEUs',
      },
    },
  },
};
